import React, { useState, useMemo, useEffect } from "react";
import Menu from "./Menu/Menu";
import useSize from "../../../../Utils/useSize/useSize";
import NotFound from "../../../../Utils/NotFound/NotFound";
import TradeCard from "./TradeCard";

export default function Trade({ trade: initialTrade, userType }) {
  const [trade, setTrade] = useState(initialTrade || []);
  const windowSize = useSize();

  // 🧠 update when parent sends new trade data
  useEffect(() => {
    setTrade(initialTrade || []);
  }, [initialTrade]);

  const handleSort = (updatedList) => {
    setTrade(updatedList);
  };

  const tradeList = useMemo(
    () => trade.map((item) => <TradeCard key={item.id} item={item} userType={userType} />),
    [trade,userType]
  );

  const containerHeight = windowSize[1] - 265;


  return (
    <div>
      <Menu trade_search={trade} handlewSort={handleSort} userType={userType} />

      <div
        style={{
          width: windowSize[0],
          height: containerHeight,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {trade.length > 0 ? (
          <div
            style={{
              width: "100%",
              height: containerHeight,
              overflowY: "auto",
            }}
          >
            {tradeList}
          </div>
        ) : (
          <NotFound height={containerHeight} title="Nothing here" subtext="No Trade Found." />
        )}
      </div>
    </div>
  );
}
